<section class="status-card-list" [class.has-detail]="hasDetailPanel" [class.standalone-list]="isStandaloneList">
  <div class="status-card-list__layout">
    <div class="status-card-list__left">
      <label class="status-card-list__search status-card-list__left-search" *ngIf="searchPlaceholder && !hasToolbarActions">
        <span class="status-card-list__search-icon" aria-hidden="true"></span>
        <input
          type="search"
          [placeholder]="searchPlaceholder"
          [value]="searchTerm"
          (input)="onSearch($any($event.target).value)" />
      </label>

      <div class="status-card-list__items" [style.gap]="gap">
        <article
          class="status-card-list__card"
          *ngFor="let item of items; let index = index"
          [ngClass]="getItemClasses(item, index)"
          (mouseenter)="activateItem(index)"
          (click)="activateItem(index)"
          (focusin)="activateItem(index)"
          tabindex="0">
          <div class="status-card-list__header">
            <div class="status-card-list__title">
              <span class="status-card-list__icon" [class.status-card-list__icon--configured]="item.icon" aria-hidden="true">
                <mat-icon>{{ item.icon || 'shield' }}</mat-icon>
              </span>
              <h3>{{ item.title }}</h3>
            </div>
            <span
              class="status-card-list__badge"
              *ngIf="item.status"
              [class.draft]="item.status.toLowerCase() === 'draft'">
              {{ item.status }}
            </span>
          </div>

          <p class="status-card-list__description" *ngIf="item.description">
            {{ item.description }}
          </p>

          <p class="status-card-list__meta" *ngIf="item.meta">{{ item.meta }}</p>

          <div class="status-card-list__tags" *ngIf="item.tags?.length">
            <span class="status-card-list__tag" *ngFor="let tag of item.tags" [class.version]="tag.variant === 'version'">
              {{ tag.label }}
            </span>
          </div>
        </article>

        <p class="status-card-list__empty" *ngIf="!items.length">
          No roles found
        </p>

      </div>

      <button
        type="button"
        class="status-card-list__sidebar-add-role"
        *ngIf="addRoleLabel"
        (click)="openAddRoleDialog()">
        <span aria-hidden="true">+</span>
        {{ addRoleLabel }}
      </button>
    </div>

    <section class="status-card-list__hierarchy-panel" *ngIf="isGlobalHierarchyActive">
      <header class="status-card-list__hierarchy-panel-header">
        {{ globalHierarchyTitle }}
      </header>

      <div class="status-card-list__hierarchy-panel-body">
        <p class="status-card-list__hierarchy-description" *ngIf="globalHierarchyDescription">
          {{ globalHierarchyDescription }}
        </p>

        <div class="status-card-list__hierarchy-content">
          <div class="status-card-list__tree-card">
            <div
              class="status-card-list__tree-row"
              *ngFor="let node of hierarchyNodes"
              [class.root]="!node.level"
              [style.--node-level]="node.level || 0">
              <span class="status-card-list__tree-connector" aria-hidden="true"></span>
              <span class="status-card-list__tree-node">{{ node.label }}</span>
            </div>
          </div>

          <aside class="status-card-list__hierarchy-side">
            <h3 *ngIf="globalHierarchySideTitle">{{ globalHierarchySideTitle }}</h3>
            <p *ngIf="globalHierarchySideDescription">{{ globalHierarchySideDescription }}</p>
            <button class="status-card-list__update-tree-button" type="button" *ngIf="globalHierarchyActionLabel">
              {{ globalHierarchyActionLabel }}
            </button>
          </aside>
        </div>
      </div>
    </section>

    <app-configurable-detail-form
      *ngIf="!isStandaloneList && !isGlobalHierarchyActive && hasDetailPanel && detailPanelType === 'configurable-detail-form'"
      [data]="activeDetailPanel"
      [contextTitle]="activeItem?.title || ''"
      [context]="activeItem"
      (statusChange)="updateActiveStatus($event)"
      (toggleChange)="updateActiveTag($event)"
      (contentChanged)="markActiveEntityDirty()"
      (actionTriggered)="handleDetailAction($event)">
    </app-configurable-detail-form>

    <app-tabbed-detail-panel
      *ngIf="!isStandaloneList && !isGlobalHierarchyActive && hasDetailPanel && detailPanelType !== 'configurable-detail-form'"
      [data]="activeDetailPanel"
      [contextTitle]="activeItem?.title || ''"
      [userRoleChanges]="userRoleChanges"
      [entityPermissionChanges]="entityPermissionChanges"
      (userRoleChange)="onUserRoleChange($event)"
      (entityPermissionChange)="onEntityPermissionChange($event)">
    </app-tabbed-detail-panel>
  </div>

  <div class="toast" [class.visible]="toastVisible" role="status" aria-live="polite">
    {{ toastMessage }}
  </div>

  <div class="add-role-dialog-backdrop" *ngIf="addRoleDialogOpen" (click)="closeAddRoleDialog()">
    <section class="add-role-dialog" role="dialog" aria-modal="true" aria-labelledby="add-role-title" (click)="$event.stopPropagation()">
      <header>
        <h2 id="add-role-title">Add New Role</h2>
        <button type="button" aria-label="Close add role dialog" (click)="closeAddRoleDialog()">×</button>
      </header>
      <div class="add-role-dialog__body">
        <label>
          <span>Role Name</span>
          <input [(ngModel)]="newRoleName" placeholder="e.g. PRODUCT_MANAGER" />
        </label>
        <label>
          <span>Description</span>
          <input [(ngModel)]="newRoleDescription" placeholder="Brief role description" />
        </label>
        <label>
          <span>Parent Role (Inherits From)</span>
          <select [(ngModel)]="newRoleParent">
            <option value="">— None (Root Role) —</option>
            <option *ngFor="let role of items" [value]="role.title">{{ role.title }}</option>
          </select>
        </label>
      </div>
      <footer>
        <button type="button" class="add-role-dialog__cancel" (click)="closeAddRoleDialog()">Cancel</button>
        <button type="button" class="add-role-dialog__create" (click)="createRole()">Create Role</button>
      </footer>
    </section>
  </div>

  <div class="add-role-dialog-backdrop" *ngIf="newEntityDialogOpen" (click)="closeNewEntityDialog()">
    <section class="add-role-dialog new-entity-dialog" role="dialog" aria-modal="true" aria-labelledby="new-entity-title" (click)="$event.stopPropagation()">
      <header>
        <h2 id="new-entity-title">New Entity</h2>
        <button type="button" aria-label="Close new entity dialog" (click)="closeNewEntityDialog()">×</button>
      </header>
      <div class="add-role-dialog__body">
        <label><span>Entity Name *</span><input [(ngModel)]="newEntityName" placeholder="e.g. product_master" /></label>
        <label><span>Display Name</span><input [(ngModel)]="newEntityDisplayName" placeholder="e.g. Product Master" /></label>
        <label class="new-entity-dialog__type"><span>Entity Type</span><select [(ngModel)]="newEntityType"><option value="NonTimeSeries">NonTimeSeries</option><option value="TimeSeries">TimeSeries</option></select></label>
        <div class="new-entity-dialog__toggles">
          <label><span>Business Entity</span><input class="new-entity-toggle" type="checkbox" [(ngModel)]="newEntityBusiness" /></label>
          <label><span>Data Versioning</span><input class="new-entity-toggle" type="checkbox" [(ngModel)]="newEntityVersioning" /></label>
        </div>
      </div>
      <footer>
        <button type="button" class="add-role-dialog__cancel" (click)="closeNewEntityDialog()">Cancel</button>
        <button type="button" class="add-role-dialog__create" [disabled]="!newEntityName.trim()" (click)="createEntity()">Create Entity</button>
      </footer>
    </section>
  </div>
</section>
